<template>
  <div class="weekly-row">
    <div class="weekly-each-day-box" v-for="day in days" v-bind:key="day.day.getTime()">
      <div class="weekly-svg-date">
        <svg width="75" height="75" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" >
          <!-- Created with Method Draw - http://github.com/duopixel/Method-Draw/ -->
          <g>
            <title>Layer 1</title>
            <ellipse fill="none" stroke="#99CB32" stroke-width="3" cx="100.5" cy="100.95313" id="svg_6" rx="91.5" ry="91.5"/>
            <line fill="none" stroke="#99CB32" stroke-width="3" x1="49" y1="154.45313" x2="154.51066" y2="48.94246" id="svg_7" stroke-linejoin="undefined" stroke-linecap="undefined"/>
            <text stroke="#99CB32" transform="matrix(1.9362200498580933,0,0,1.814814805984497,-43.06612229347229,-38.66550884023309) " xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="24" id="svg_1" y="71.65721" x="42.90118" fill-opacity="null" stroke-opacity="null" stroke-width="0" fill="#99CB32">{{day.day.getDate()}}</text>
            <text style="cursor: move;" stroke="#99CB32" transform="matrix(1.9362200498580933,0,0,1.814814805984497,-43.06612229347229,-38.66550884023309) " xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="24" id="svg_2" y="101.41231" x="79.57056" fill-opacity="null" stroke-opacity="null" stroke-width="0" fill="#99CB32">{{day.day.getMonth() + 1}}</text>
          </g>
        </svg>
        <div class="weekly-light-green-font">{{weekNames[day.day.getDay()]}}</div>
      </div>
      <div class="weekly-each-day-mission">
        <div v-for="(mission, indexMission) in day.missions.list" v-bind:key="indexMission" class="weekly-box-content">
          <!-- <div>{{ mission.name }}</div> -->
          <router-link :to="{
            name: 'ClassActivity',
            query: mission.query
            }">班級：{{mission.course_title}}，任務：{{ mission.name }}</router-link>
        </div>
        <div v-if="day.missions.hvMore" @click="goToDate(day.day)" class="more">查看更多...</div>
      </div>
      <!-- <div class="weekly-expected-time weekly-green-font">預計時間：{{date.expected_time}}分鐘</div> -->
    </div>
  </div>
</template>
<style scoped>
  .weekly-light-green-font{
    color: #99CB32;
    font-size: 1rem;
  }
  .weekly-row{
    padding:1rem;
  }
  .weekly-green-font{
    color: #387E1E;
  }
  .weekly-finish{
    color: #878A8B;
  }
  .weekly-unfinish{
    color: #387E1E;
  }
  .weekly-expected-time{
    position:absolute;
    right:0.5rem;
    bottom:0.2rem;
  }
  .weekly-each-day-box{
    position:relative;
    margin: 1rem;
    border: 1px solid #99CB32;
    border-radius: 5px;
    display:flex;
  }
  .weekly-svg-date{
    margin: 0.8rem 1.5rem;
    display:flex;
  }
  .weekly-each-day-mission{
    margin: 0.8rem 1.5rem;
    font-size: 1rem;
  }
  .weekly-each-row{
    height: 1rem;
  }
  .more{
    color: green;
    cursor: pointer;
  }
  .more:hover{
    text-decoration: underline;
  }
</style>
<script>
var moment = require('moment')
export default {
  props: {
    year: Number,
    month: Number,
    date: Number
  },
  data () {
    return {
      weekNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      today: (this.year && this.month && this.date) ? new Date(this.year, this.month, this.date) : new Date(),
      missions: []
    }
  },
  computed: {
    firstDay: function () {
      return new Date(this.today.getTime() - this.today.getDay() * 86400000)
    },
    endDay: function () {
      return new Date(this.today.getTime() + (6 - this.today.getDay()) * 86400000)
    },
    days: function () {
      var days = []
      var day = new Date(this.firstDay)
      while (true) {
        let missionList = this.missions.filter(mission => {
          return moment(day).format('YYYY-MM-DD') === moment(mission.endDatetime).format('YYYY-MM-DD')
          // return day === new Date(mission.endDatetime)
        })
        let dayObject = {
          day: new Date(day),
          missions: {
            list: missionList.slice(0, 2),
            hvMore: missionList.length > 2
          }
        }
        days.push(dayObject)
        day.setTime(day.getTime() + 86400000)
        if (day > this.endDay) break
      }
      return days
    }
  },
  methods: {
    goToDate: function (date) {
      // console.log(date)
      console.log(this.$parent)
      this.$parent.initYear = date.getFullYear()
      this.$parent.initMonth = date.getMonth()
      this.$parent.initDate = date.getDate()
      this.$parent.switchDaily()
      // console.log(this)
      // this.$router.push({
      //   query: {
      //     year: date.getFullYear(),
      //     month: date.getMonth(),
      //     date: date.getDate()
      //   }
      // })
    }
  },
  updated () {
    console.log('weekly updated')
  },
  async mounted () {
    console.log('here is weekly')
    this.$emit('loading')
    let res = await this.$store.dispatch('request', {
      route: `activities?start=${this.firstDay.getFullYear()}-${this.firstDay.getMonth() + 1}-${this.firstDay.getDate()}&end=${this.endDay.getFullYear()}-${this.endDay.getMonth() + 1}-${this.endDay.getDate()}&type=weeks`
    })
    this.missions = res.activities
    this.$emit('loaded')
  }
}
</script>
